var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73138 4.34952C9.73115 4.34929 9.73092 4.34906 9.73069 4.34883L5.65107 0.269775C5.47718 0.0958252 5.24598 0 5.00006 0C4.75414 0 4.52295 0.0957489 4.34898 0.269699L0.271492 4.34669C0.270118 4.34807 0.268745 4.34952 0.267372 4.35089C-0.0897206 4.71001 -0.0891102 5.29266 0.269126 5.65086C0.432794 5.81459 0.648956 5.90942 0.880074 5.91934C0.889459 5.92026 0.898921 5.92072 0.908459 5.92072H1.07106V8.92265C1.07106 9.51668 1.55443 10 2.14867 10H3.74475C3.90651 10 4.03774 9.86885 4.03774 9.70703V7.35352C4.03774 7.08244 4.25826 6.86195 4.52936 6.86195H5.47077C5.74187 6.86195 5.96238 7.08244 5.96238 7.35352V9.70703C5.96238 9.86885 6.09354 10 6.25538 10H7.85146C8.44569 10 8.92907 9.51668 8.92907 8.92265V5.92072H9.07984C9.32568 5.92072 9.55688 5.82497 9.73092 5.65102C10.0895 5.29221 10.0897 4.70856 9.73138 4.34952Z",
    fill: "#FF9B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressCard);
export default __webpack_public_path__ + "static/media/address-card.d70bdd60e4954f60a841df5a2d8a7333.svg";
export { ForwardRef as ReactComponent };